import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReportTemplateField} from '../../interfaces/ReportTemplateField';

@Component({
  selector: 'app-template-field-list-item',
  templateUrl: './template-field-list-item.component.html',
  styleUrls: ['./template-field-list-item.component.scss']
})
export class TemplateFieldListItemComponent implements OnInit {

  public _reportTemplateField: ReportTemplateField;

  @Input() letters: string[] = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
    'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
    'Y', 'Z'
  ];

  @Output() reportTemplateFieldChange = new EventEmitter();


  @Input()
  public set reportTemplateField(value) {
    this._reportTemplateField = value;
    this.reportTemplateFieldChange.emit(this._reportTemplateField);
  }

  public get reportTemplateField() {
    return this._reportTemplateField;
  }


  @Output() onRemove = new EventEmitter();

  operators = [
    { name: 'Greater than', value: '>'},
    { name: 'Less than', value: '<'},
    { name: 'Greater than or equal to', value: '>='},
    { name: 'Less than or equal to', value: '<='},
    { name: 'Equals', value: '='}
  ];
  constructor() { }

  ngOnInit() {

  }

  addNewWhere() {
    this.reportTemplateField.where_statements.push({
      operator: '=',
      value: ''
    })
  }



}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/components/template-field-list-item/template-field-list-item.component.ts